up.compiler('.js-disable_plan_cta_with_alert', element => {
  element.addEventListener('click', event => {
    const alertText = element.dataset.alertText
    alert(alertText)
    event.preventDefault()
    return false
  })
})
